"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _default = function _default(_ref) {
  var children = _ref.children;
  return _react.default.createElement("div", {
    className: "subtitle"
  }, children);
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/Subtitle.js
// module id = 71
// module chunks = 0